// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_title_JYDa2 {
  font-size: 80px;
  font-family: GothamRounded-Medium;
  white-space: nowrap;
}

.header_subtitle_ZVhhn {
  font-family: GothamRounded-Book;
}

.header_small_oqLsS {
  font-size: 24px;
}

.header_item_RJ1Ns {
  max-height: 160px;
  margin: 0 15px;
}

.header_stop_MsXNF {
  margin-top: 10px;
  padding: 0 20px;
  font-size: 55px;
  text-align: center;
  border: 5px solid white;
  border-radius: 10px;
}

.header_stopZoneColumn_BJQgB {
  display: flex;
  flex-direction: row;
}

.header_zoneHeading_PVuiL {
  margin-right: 50px;
}

.header_zone_F2kXe {
  position: relative;
  box-sizing: border-box;
  flex: none;
  margin-top: 8px;
  width: 170px;
  height: 170px;
  color: var(--background);
  background: white;
  border-radius: 50%;
}

/* TODO: Fix each letter. Current is best for C. */

.header_zoneLetter_XlLVE {
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  line-height: 1;
  font-family: GothamRounded-Medium;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/components/stopPoster/header.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EAEE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kDAAkD;;AAElD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,yBAAyB;AAC3B","sourcesContent":[".title {\n  font-size: 80px;\n  font-family: GothamRounded-Medium;\n  white-space: nowrap;\n}\n\n.subtitle {\n  composes: title;\n  font-family: GothamRounded-Book;\n}\n\n.small {\n  font-size: 24px;\n}\n\n.item {\n  max-height: 160px;\n  margin: 0 15px;\n}\n\n.stop {\n  composes: title;\n  margin-top: 10px;\n  padding: 0 20px;\n  font-size: 55px;\n  text-align: center;\n  border: 5px solid white;\n  border-radius: 10px;\n}\n\n.stopZoneColumn {\n  display: flex;\n  flex-direction: row;\n}\n\n.zoneHeading {\n  margin-right: 50px;\n}\n\n.zone {\n  position: relative;\n  box-sizing: border-box;\n  flex: none;\n  margin-top: 8px;\n  width: 170px;\n  height: 170px;\n  color: var(--background);\n  background: white;\n  border-radius: 50%;\n}\n\n/* TODO: Fix each letter. Current is best for C. */\n\n.zoneLetter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  text-align: center;\n  line-height: 1;\n  font-family: GothamRounded-Medium;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `header_title_JYDa2`,
	"subtitle": `header_subtitle_ZVhhn header_title_JYDa2`,
	"small": `header_small_oqLsS`,
	"item": `header_item_RJ1Ns`,
	"stop": `header_stop_MsXNF header_title_JYDa2`,
	"stopZoneColumn": `header_stopZoneColumn_BJQgB`,
	"zoneHeading": `header_zoneHeading_PVuiL`,
	"zone": `header_zone_F2kXe`,
	"zoneLetter": `header_zoneLetter_XlLVE`
};
module.exports = ___CSS_LOADER_EXPORT___;
